import React from 'react';
import { Link } from 'react-router-dom';
import { Play, Lock, BarChart2 } from 'lucide-react';
import { useLang, pickLocalized, tx } from '../../i18n/LanguageContext';
import { levelLabel } from './simUtils';

export const SimCard = ({ sim, index }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  return (
    <div className="art-reveal flex" style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}>
      <article data-testid={`sim-card-${sim.id}`} style={{ '--glow': '#2563eb' }}
        className="plan-glow group w-full flex flex-col bg-white rounded-2xl border border-slate-200/80 p-2.5 shadow-[0_6px_24px_-12px_rgba(15,23,42,0.15)]">
        <div className="relative aspect-[16/9] overflow-hidden rounded-xl bg-slate-100">
          <img src={sim.image} alt="" loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          <span data-testid={`sim-interactive-badge-${sim.id}`} className="absolute top-2.5 start-2.5 px-3 py-1 rounded-lg text-xs font-bold bg-emerald-500 text-white shadow-sm">{L('تفاعلية', 'Interactive')}</span>
          <span data-testid={`sim-access-badge-${sim.id}`} className={`absolute top-2.5 end-2.5 inline-flex items-center gap-1 px-2.5 py-1 rounded-lg text-xs font-bold shadow-sm ${sim.is_free ? 'bg-white/90 text-emerald-700' : 'bg-slate-900/75 backdrop-blur text-amber-300'}`}>
            {sim.is_free ? L('مجانية', 'Free') : <><Lock className="w-3 h-3" />{L('للمشتركين', 'Members')}</>}
          </span>
        </div>
        <div className="flex-1 flex flex-col px-2.5 pt-4 pb-1">
          <span data-testid={`sim-level-${sim.id}`} className="self-start inline-flex items-center gap-1.5 text-emerald-700 text-xs font-bold mb-2"><BarChart2 className="w-3.5 h-3.5" />{levelLabel(sim.level, lang)}</span>
          <h3 className="text-slate-900 font-black text-base sm:text-lg leading-snug mb-2 line-clamp-2">{pickLocalized(sim.title, lang)}</h3>
          <p className="text-slate-500 text-sm leading-relaxed line-clamp-2 mb-4 flex-1">{pickLocalized(sim.excerpt, lang)}</p>
          {sim.hasHtml ? (
            <Link to={`/simulations/${sim.id}`} data-testid={`sim-start-btn-${sim.id}`}
              className="h-11 rounded-xl bg-blue-50 hover:bg-blue-600 text-blue-700 hover:text-white font-bold text-sm inline-flex items-center justify-center gap-2 transition-colors">
              <Play className="w-4 h-4 fill-current" />{L('ابدأ المحاكاة', 'Start simulation')}
            </Link>
          ) : (
            <button type="button" disabled data-testid={`sim-start-btn-${sim.id}`} title={L('قريباً', 'Coming soon')}
              className="h-11 rounded-xl bg-slate-50 text-slate-400 font-bold text-sm inline-flex items-center justify-center gap-2 cursor-not-allowed">
              <Play className="w-4 h-4 fill-current" />{L('ابدأ المحاكاة', 'Start simulation')}
              <span className="text-[11px] font-semibold">({L('قريباً', 'soon')})</span>
            </button>
          )}
        </div>
      </article>
    </div>
  );
};
